import { readLocal, writeLocal } from './storage';

/*
 * Boards are kept in this browser's IndexedDB so they open at once and work
 * offline. That copy outlives the session that made it, so signing out wipes
 * it: the next person at this computer must not find someone else's boards.
 */

const PREFIX = 'doriavboard:';
const KEY = 'doriavboard.cachedBoards';

/** The name of the IndexedDB database holding a board's offline copy. */
export function boardCacheName(boardId: string): string {
  return `${PREFIX}${boardId}`;
}

/** Notes that this browser now holds a copy of the board. */
export function rememberBoardCache(boardId: string): void {
  const known = readLocal<string[]>(KEY, []);
  if (!known.includes(boardId)) writeLocal(KEY, [...known, boardId]);
}

/** Deletes every board copy this browser holds. */
export async function clearBoardCaches(): Promise<void> {
  const names = new Set(readLocal<string[]>(KEY, []).map(boardCacheName));
  try {
    // Where the browser can list its databases, catch copies made before the
    // list above was kept.
    for (const { name } of (await indexedDB.databases?.()) ?? []) {
      if (name?.startsWith(PREFIX)) names.add(name);
    }
  } catch {
    // The list we keep ourselves will do.
  }
  for (const name of names) {
    try {
      indexedDB.deleteDatabase(name);
    } catch {
      // Storage is unavailable: there is nothing to delete.
    }
  }
  writeLocal(KEY, []);
}
